import project1 from "./resimler/project1.png";
import project2 from "./resimler/project2.png";
export const projects = [
  {
    image: project1,
    isim: "Technological Dishes",
    aciklama:
      "A simple, customizable, minimal setup cookie plugin that allows your users to select which cookies to accept or decline. This was created with vanilla JS, SCSS and Parcel Bundler and is available as a NPM package and the git repository makes any type of customization to code and themes possible.",
    kullanilanlar: ["react", "cypress", "react hook form"],
    link1: "https://teknojikyemekler.vercel.app/",
    link2: "https://github.com/iremcelebii/FSWeb-S7-Challenge",
  },
  {
    image: project2,
    isim: " Watch List",
    aciklama:
      "A simple, customizable, minimal setup cookie plugin that allows your users to select which cookies to accept or decline. This was created with vanilla JS, SCSS and Parcel Bundler and is available as a NPM package and the git repository makes any type of customization to code and themes possible.",
    kullanilanlar: ["react", "redux", "redux-logger"],
    link1: "https://watchlist-ashy.vercel.app/",
    link2: "https://github.com/iremcelebii/fsweb-s10g3-redux-watchlist",
  },
];
